import { Injectable } from '@angular/core';
import { Usuario } from '../model/usuario';
import { Router } from '@angular/router';
import { Http } from '@angular/http';
import { Observable } from 'rxjs';
import { API_PATH } from '../util/constants';
import "rxjs/add/operator/toPromise";
import "rxjs/add/operator/catch";

@Injectable()
export class LoginService {

  usuarioLogado: boolean = false;
  private headers: Headers;
  private opcoes;
  private url;

  constructor(private http: Http) {
    this.headers = new Headers({
      "Allow-Control-Allow-Origin": "*",
      "Allow-Control-Allow-Methods": "GET, POST, PUT, DELETE",
      "Content-Type": "application/json"
    });
    this.opcoes = {headers: this.headers}
  }

  login(data) {
    return this.http.post(`${API_PATH}/login`, data, this.opcoes)
    .map(res=>res.json())
    .catch(err=> Observable.throw(err.message));
  }

  logado(): boolean {
    if (!!sessionStorage.getItem("usuario")) {
      this.usuarioLogado = true;
    } else {
      this.usuarioLogado = false;
    }
    return this.usuarioLogado;
  }

}


// WEBPACK FOOTER //
// ./src/app/login/login.service.ts